import { createReducer, createActions } from 'reduxsauce';

export const INITIAL_STATE = {};

const { Types, Creators } = createActions( {
  updateInfo: ['data'],
} );

const updateInfo = ( state, { data } ) => ( { ...state, ...data } );

export const reducer = createReducer( INITIAL_STATE, {
  [Types.UPDATE_INFO]: updateInfo,
} );

export const AccountTypes = Types;
export default Creators;
